export default {
  "login": "rjgupta",
  "id": 24679384,
  "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
  "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/rjgupta",
  "html_url": "https://github.com/rjgupta",
  "followers_url": "https://api.github.com/users/rjgupta/followers",
  "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
  "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
  "organizations_url": "https://api.github.com/users/rjgupta/orgs",
  "repos_url": "https://api.github.com/users/rjgupta/repos",
  "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
  "received_events_url": "https://api.github.com/users/rjgupta/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Rajat Gupta",
  "company": null,
  "blog": "https://www.rjgupta.com/",
  "location": "New York, NY",
  "email": null,
  "hireable": true,
  "bio": "I'm looking for full-time job opportunities so if you've an opportunity for me please feel free to drop me an email!",
  "twitter_username": "rjgupta21",
  "public_repos": 72,
  "public_gists": 2,
  "followers": 43,
  "following": 139,
  "created_at": "2016-12-20T14:01:56Z",
  "updated_at": "2020-07-15T22:58:39Z"
};
